import React from "react";

/**
 * Vangnet: toont een vriendelijke melding i.p.v. een wit scherm wanneer er een
 * onverwachte (render)fout optreedt — bijv. door browser-vertaling die de DOM aanpast.
 */
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("App crash opgevangen:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          data-testid="app-error-boundary"
          style={{
            minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
            background: "#050507", color: "#fff", padding: 24, textAlign: "center",
            fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
          }}
        >
          <div style={{ maxWidth: 420 }}>
            <div style={{ fontSize: 22, fontWeight: 800, marginBottom: 8 }}>
              Slim<span style={{ color: "#00FFD1" }}>Avontuur</span>
            </div>
            <h1 style={{ fontSize: 20, fontWeight: 800, margin: "0 0 8px" }}>Er ging even iets mis</h1>
            <p style={{ color: "#9aa0b4", fontSize: 15, lineHeight: 1.6, margin: "0 0 20px" }}>
              Ververs de pagina om verder te gaan. Gebruik je de automatische vertaling van je
              browser? Schakel die eventueel uit als het probleem blijft.
            </p>
            <button
              data-testid="error-reload-btn"
              onClick={() => window.location.reload()}
              translate="no"
              style={{
                background: "#00FFD1", color: "#000", fontWeight: 800, fontSize: 15,
                border: 0, borderRadius: 999, padding: "12px 24px", cursor: "pointer",
              }}
            >
              Pagina verversen
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
